export interface IPropertyType {
  key: string;
  subtypes: string[];
}

export const PROPERTY_TYPES: IPropertyType[] = [
  {
    key: 'Residential',
    subtypes: [
      'SINGLE_FAMILY',
      'MULTI_FAMILY',
      'ROW_HOUSE',
      'TOWN_HOUSE',
      'CONDOMINIUM',
      'MOBILE_HOUSE',
      'APARTMENTS',
    ],
  },
  { key: 'Commercial', subtypes: ['COMMERCIAL'] },
  { key: 'Land', subtypes: ['VACANT_LAND', 'FARM_LAND'] },
];
